export default "__VITE_ASSET__9897c0bf__"